<template>
	<v-footer class="footer" v-bind="footerAttrs" app>
		<v-container class="py-1">
			<v-row>
				<v-col cols="6" class="py-0 px-2">
					<v-sheet
						class="text-center"
						tile
						@click="$emit('click:tab', 'community')"
					>
						<p class="overline">Community</p>
						<p class="body-2 text-truncate">
							{{ (community && community.name) || unselectedTxt }}
						</p>
					</v-sheet>
				</v-col>

				<v-col cols="6" class="py-0 px-2">
					<v-sheet class="text-center" tile @click="$emit('click:tab', 'room')">
						<p class="overline">Room</p>
						<p class="body-2 text-truncate">
							{{ (system && system.name) || unselectedTxt }}
						</p>
					</v-sheet>
				</v-col>
			</v-row>
		</v-container>
	</v-footer>
</template>

<style lang="scss" scoped>
.footer {
	background-color: var(--v-secondary-base);

	p {
		margin: 0;
	}
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
	props: [],

	data: () => ({
		unselectedTxt: "Not selected",

		footerAttrs: {
			dark: true,
			padless: true,
			inset: true, // Makes room for drawer navigation
			fixed: true,
		},
	}),

	computed: {
		...mapGetters({
			community: "session/community",
			system: "session/system",
		}),
	},
};
</script>
